import React from 'react';
import {contains} from "underscore";

export const AreaControlList = (props) => {

    const doNothing = () => {
    };

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="row mt-1">
                    <div className="col-lg-12 pre-scrollable" style={{maxHeight: '500px'}}>
                        <table className="table table-striped" style={{fontSize: 'x-small'}}>
                            <thead>
                            <tr>
                                <th style={{verticalAlign: 'middle'}}>
                                    <input name="selectItem" type="checkbox"
                                           checked={Object.keys(props.selectedItems).length > 0}
                                           onChange={props.toggleAllItems}/>
                                </th>
                                <th>SAP-Artikel</th>
                                <th>Name</th>
                                <th>GTIN</th>
                                <th>Hersteller-Artikelnummer</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {props.areaControlledItems.map((item, index) => {

                                const isSelected = contains(props.selectedItems, item.id);

                                return (
                                    <tr key={index} onClick={() => props.toggleItemSelection(item.id)}>
                                        <td style={{verticalAlign: 'middle'}}>
                                            <input name="selectItem" type="checkbox" checked={isSelected}
                                                   onChange={doNothing}/>
                                        </td>
                                        <td>{item.erpIdno}</td>
                                        <td>{item.articleDetails}</td>
                                        <td>{item.gtin}</td>
                                        <td>{item.vendorArticleNumber}</td>
                                        <td></td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default AreaControlList;


// WEBPACK FOOTER //
// ./src/admin/areacontrol/admin/AreaControlList.js